var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhishfortLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 199,
    height: 22.223,
    viewBox: "0 0 199 22.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1023",
    "data-name": "Rectangle 1023",
    width: 107.16,
    height: 22.223,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1022",
    "data-name": "Rectangle 1022",
    width: 107.16,
    height: 22.224,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 12.101,
    height: 4.477,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2361",
    "data-name": "Group 2361",
    transform: "translate(-1121 -405.477)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Powered_by",
    "data-name": "Powered by",
    transform: "translate(1164 423)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "WorkSans-SemiBold, Work Sans",
    fontWeight: 600,
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -42,
    y: 0
  }, "POWERED BY")), /*#__PURE__*/React.createElement("g", {
    id: "Group_2130",
    "data-name": "Group 2130",
    transform: "translate(1212.84 405.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2129",
    "data-name": "Group 2129",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M98.915,30.777l-2.1-3.483h2.1Z",
    transform: "translate(-67.433 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M117.7,30.777V27.294h2.087Z",
    transform: "translate(-81.983 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M98.915,45.271l-2.1,3.5h2.1Z",
    transform: "translate(-67.433 -31.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M117.7,45.271l2.087,3.5H117.7Z",
    transform: "translate(-81.983 -31.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M99.509,31.762l-2.694-4.468v8.952Z",
    transform: "translate(-67.434 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M115.705,31.762l2.694-4.468v8.952Z",
    transform: "translate(-80.591 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M107.37,42.021h-3.041l-.592.986h4.226Z",
    transform: "translate(-72.254 -29.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M107.37,39.762h-3.041l-.592-.986h4.226Z",
    transform: "translate(-72.254 -27.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M99.509,31.762l-2.694-4.468v8.952Z",
    transform: "translate(-67.434 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M188.339,30.777l-2.1-3.483h2.1Z",
    transform: "translate(-129.719 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M207.128,30.777V27.294h2.087Z",
    transform: "translate(-144.269 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M188.339,45.271l-2.1,3.5h2.1Z",
    transform: "translate(-129.719 -31.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M207.128,45.271l2.087,3.5h-2.087Z",
    transform: "translate(-144.269 -31.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M188.933,31.762l-2.694-4.468v8.952Z",
    transform: "translate(-129.719 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M205.13,31.762l2.694-4.468v8.952Z",
    transform: "translate(-142.877 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M196.794,42.021h-3.041l-.592.986h4.226Z",
    transform: "translate(-134.54 -29.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M196.794,39.762h-3.041l-.592-.986h4.226Z",
    transform: "translate(-134.54 -27.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M188.933,31.762l-2.694-4.468v8.952Z",
    transform: "translate(-129.719 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M326.351,27.294l3.01,1.946h-3.01Z",
    transform: "translate(-227.31 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M343.188,29.24H346.2V27.294Z",
    transform: "translate(-239.037 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M326.351,27.294l4.06,2.625,4.059-2.625Z",
    transform: "translate(-227.31 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M338.368,53.528l-1.05-1.421-1.05,1.421Z",
    transform: "translate(-234.217 -36.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M337.318,39.292V34.387l-1.05-.679v7.005l1.05-1.421Z",
    transform: "translate(-234.217 -23.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M339.728,34.387v4.905l1.05,1.421V33.708Z",
    transform: "translate(-236.628 -23.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M137.4,53.528l-1.05-1.421-1.05,1.421Z",
    transform: "translate(-94.241 -36.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M136.351,34.824V28.715L135.3,27.294v8.951Z",
    transform: "translate(-94.24 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M139.812,27.294l-1.05,1.421v6.109l1.05,1.421Z",
    transform: "translate(-96.65 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M135.3,27.294l1.05,1.421,1.05-1.421Z",
    transform: "translate(-94.24 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M62.421,27.294l2.1,1.908-2.1,1.441Z",
    transform: "translate(-43.477 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M64.521,36.463l-2.1-1.441,2.1-1.441Z",
    transform: "translate(-43.477 -23.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M64.521,39.77l-2.1,4.162v-5.6Z",
    transform: "translate(-43.477 -26.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M64.521,47.238h-2.1l2.1-4.162Z",
    transform: "translate(-43.477 -30.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M62.421,27.294H65.75L64.521,29.2Z",
    transform: "translate(-43.477 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M79.862,30.273l.953-1.845,1.025.8L80.116,30.5Z",
    transform: "translate(-55.625 -19.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M78.461,27.294l-.155,1.97.472.219.953-1.845Z",
    transform: "translate(-54.542 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M74.553,29.2l.33.063.155-1.971H73.392Z",
    transform: "translate(-51.119 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M71.731,29.2h-2.39l1.229-1.908Z",
    transform: "translate(-48.297 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M80.7,32.329l1.723-1.269.534.945-2.034.659Z",
    transform: "translate(-56.209 -21.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M81.433,34.833l2.034-.659.226,1.1H81.557Z",
    transform: "translate(-56.72 -23.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M83.879,37.794l-.133,1.111L81.7,38.35l.043-.556Z",
    transform: "translate(-56.906 -26.325)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M81.139,40l1.778,1.2.438-1.024-2.046-.556Z",
    transform: "translate(-56.515 -27.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M81.4,42.849l.857-.778-1.778-1.2-.287.319Z",
    transform: "translate(-55.857 -28.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M79.368,41.921l-.36.216.513,1.931,1.055-.487Z",
    transform: "translate(-55.031 -29.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M77.656,42.633l-.589.134.089,1.905,1.014-.108Z",
    transform: "translate(-53.679 -29.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M69.342,44.981l1.078-1.905H69.342Z",
    transform: "translate(-48.298 -30.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M71.775,44.981,70.42,43.076l-1.078,1.905Z",
    transform: "translate(-48.298 -30.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M74.16,43.076H72.893l1.355,1.905Z",
    transform: "translate(-50.771 -30.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M224.348,27.294l2.1,1.947,5.327-1.947Z",
    transform: "translate(-156.263 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M236.6,29.241h-5.327l5.327-1.947Z",
    transform: "translate(-161.083 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M224.348,31.092l2.1-1.852-2.1-1.947Z",
    transform: "translate(-156.263 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M226.449,37.64l-2.1-2.08,2.1-1.852Z",
    transform: "translate(-156.263 -23.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M224.348,44.963l2.1-3.073-2.1-2.08Z",
    transform: "translate(-156.263 -27.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M226.449,49.737V46.663l-2.1,3.073Z",
    transform: "translate(-156.263 -32.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M235.635,40.249,231.269,42.2h4.367Z",
    transform: "translate(-161.083 -28.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M231.268,40.249h4.367L231.268,42.2Z",
    transform: "translate(-161.083 -28.034)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M295.829,31.545l-2.1-4.252h2.1Z",
    transform: "translate(-204.588 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M293.728,36.246l2.1-4.7-2.1-4.251Z",
    transform: "translate(-204.588 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M295.829,46V41.3l-2.1,4.7Z",
    transform: "translate(-204.588 -28.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M308.666,29.227l.673.117.9-1.82-1.114-.231Z",
    transform: "translate(-214.992 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M311.341,30.192l-.457-.319.9-1.82.917.563Z",
    transform: "translate(-216.536 -19.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M306.5,27.294h-1.6l1.142,1.934Z",
    transform: "translate(-212.371 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M300.648,29.227l1.291-1.934,1.142,1.934Z",
    transform: "translate(-209.408 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M300.648,27.294h1.291l-1.291,1.934Z",
    transform: "translate(-209.408 -19.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M312.391,31.484l1.361-1.575.651.829-1.853,1Z",
    transform: "translate(-217.586 -20.832)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M312.913,33.644l1.853-1,.285.814-2.068.415Z",
    transform: "translate(-217.95 -22.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M313.169,36.065h2.112l-.068-.743-2.068.415Z",
    transform: "translate(-218.112 -24.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M313.007,37.771l-.094.392,2.085.449.121-.842Z",
    transform: "translate(-217.95 -26.308)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M312.6,39.064l2.085.449-.336.72-1.885-.928Z",
    transform: "translate(-217.639 -27.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M312.359,39.644l1.848.993-.478.576-1.469-1.449Z",
    transform: "translate(-217.495 -27.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M311.871,40.041l-.169.142,1.085,1.719.553-.412Z",
    transform: "translate(-217.107 -27.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M310.649,42.787l1.079-.559-1.086-1.719-.461.193Z",
    transform: "translate(-216.047 -28.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M316.147,49.766l-2.292-3.061-.167,3.061Z",
    transform: "translate(-218.49 -32.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M307.639,41.145l-1.108.048,1.575,2.037Z",
    transform: "translate(-213.504 -28.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M302.544,43.25l-1.9-1.947V43.25Z",
    transform: "translate(-209.408 -28.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M302.434,41.3l.11,1.947-1.9-1.947Z",
    transform: "translate(-209.408 -28.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M308.106,43.341l-1.465-.09-.11-1.947Z",
    transform: "translate(-213.504 -28.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M308.956,50.471l-2.062-2.753,1.465.09Z",
    transform: "translate(-213.758 -33.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M312.485,46.705l-.763.4.6,2.663Z",
    transform: "translate(-217.12 -32.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M172.142,30.112l.756-1.69-1-.428-.488,1.828Z",
    transform: "translate(-119.388 -19.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M169.926,29.29l.488-1.828-.9-.232-.234,1.88Z",
    transform: "translate(-117.907 -18.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M167.481,28.737l.546.107.234-1.88-.781-.115Z",
    transform: "translate(-116.654 -18.701)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M164.794,26.757l-1.171-.04.541,1.86.629.067Z",
    transform: "translate(-113.966 -18.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M161.016,28.6l.813-.018-.541-1.86-1.018.107Z",
    transform: "translate(-111.631 -18.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M159.076,28.84l-.6.134-.99-1.674.845-.232Z",
    transform: "translate(-109.691 -18.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M155,28.219l.755-.386.99,1.674-.314.2Z",
    transform: "translate(-107.958 -19.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M155.186,30.6l-.119.2-1.854-1.174.541-.516Z",
    transform: "translate(-106.716 -20.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M154.314,31.979l-.025.227-2.157-.764.328-.638Z",
    transform: "translate(-105.963 -21.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M154.113,33.671l-2.157-.764-.076.895h2.269Z",
    transform: "translate(-105.787 -22.92)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M154.149,35.855l.108.157-2.181.6-.2-.758Z",
    transform: "translate(-105.787 -24.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M154.707,36.372l-2.181.6.394.593,1.869-1.12Z",
    transform: "translate(-106.238 -25.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M153.824,37.735l1.869-1.12.191.125-1.516,1.431Z",
    transform: "translate(-107.142 -25.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M155.618,38.459l1.516-1.431.371.167-1.134,1.647Z",
    transform: "translate(-108.391 -25.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M159.231,37.578l.388.133-.708,1.793-.815-.279Z",
    transform: "translate(-110.118 -26.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M161.489,38.015l.556.164L161.88,40.1l-1.1-.3Z",
    transform: "translate(-111.987 -26.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M165.1,40.69l-.7-.21.165-1.925,1,.3Z",
    transform: "translate(-114.51 -26.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M167.98,39.837l-.806-.3-.469,1.837.4.171Z",
    transform: "translate(-116.113 -27.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M168.3,42.416l-.273-.181.873-1.708.64.33Z",
    transform: "translate(-117.037 -28.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M169.058,43.314l-.128-.139,1.24-1.558.528.393Z",
    transform: "translate(-117.663 -28.987)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M169.353,44.216l.1.208,2-.908-.457-.6Z",
    transform: "translate(-117.958 -29.889)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M169.689,46.029l-.015-.222,2-.908.249.748Z",
    transform: "translate(-118.182 -31.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M169.585,47.9l2.237.287.037-.829-2.233.382Z",
    transform: "translate(-118.12 -32.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M171.287,50.191l.25-.756-2.237-.287-.124.188Z",
    transform: "translate(-117.834 -34.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M171.023,50.623l-2.111-.855-.115.1,1.726,1.354Z",
    transform: "translate(-117.571 -34.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M170.143,51.447l-1.726-1.354-.166.1,1.17,1.714Z",
    transform: "translate(-117.19 -34.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M168.727,52.124l-.856.283-.617-1.892.3-.105",
    transform: "translate(-116.496 -35.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M167.138,52.648l-.8.114-.14-1.947.32-.059Z",
    transform: "translate(-115.763 -35.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M164.835,50.951l-.441.03-.154,1.947.735-.03Z",
    transform: "translate(-114.396 -35.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M161.633,52.938l.791.039.154-1.948-.4-.008Z",
    transform: "translate(-112.581 -35.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M160.289,50.888l-.53-.058-.842,1.86.824.115Z",
    transform: "translate(-110.689 -35.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M156.689,52.285l.676.157.842-1.86-.557-.108Z",
    transform: "translate(-109.137 -35.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M155.547,50.042l-.679-.188-1.2,1.685.916.314Z",
    transform: "translate(-107.034 -34.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M153.428,49.174l.578.207-1.2,1.685-.376-.167Z",
    transform: "translate(-106.172 -34.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M151.255,50.173l.357.181,1-1.725-.547-.237Z",
    transform: "translate(-105.352 -33.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M269.713,28.149V26.194l1.115.129-.457,1.9Z",
    transform: "translate(-187.861 -18.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M266.041,26.323l1.115-.129v1.955l-.657.076Z",
    transform: "translate(-185.302 -18.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M272.337,26.619l1.055.38-.89,1.747-.622-.224Z",
    transform: "translate(-189.369 -18.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M262.565,27l1.055-.38.457,1.9-.622.224Z",
    transform: "translate(-182.882 -18.54)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M274.819,27.87l.938.61-1.275,1.5-.553-.36Z",
    transform: "translate(-190.797 -19.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M260.413,27.87l-.938.61,1.275,1.5.553-.36Z",
    transform: "translate(-180.73 -19.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M258.529,31.852l-1.591-1.165.77-.808,1.275,1.5Z",
    transform: "translate(-178.962 -20.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M277.025,29.879l.77.808L276.2,31.852l-.454-.476Z",
    transform: "translate(-192.065 -20.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M257.241,33.705l-.331.567-1.821-.771.561-.961Z",
    transform: "translate(-177.674 -22.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M277.246,33.705l.331.567L279.4,33.5l-.561-.961Z",
    transform: "translate(-193.107 -22.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M255.982,37.105l.19-.627-1.821-.771-.322,1.063Z",
    transform: "translate(-176.936 -24.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M253.814,40.32l1.98-.121.039-.653-1.954-.334Z",
    transform: "translate(-176.786 -27.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M254.008,43.679l1.9-.569-.115-.645-1.98.121Z",
    transform: "translate(-176.786 -29.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M256.618,45.191l-.262-.6-1.9.569.445,1.019Z",
    transform: "translate(-177.234 -31.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M258.034,47.095l-1.443,1.353-.67-.89,1.718-.988Z",
    transform: "translate(-178.254 -32.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M278.336,36.478l.19.627,1.953-.334-.322-1.063Z",
    transform: "translate(-193.867 -24.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M259.572,48.3l.507.421-1.09,1.646-.86-.713Z",
    transform: "translate(-179.792 -33.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M262.643,49.98l-.591-.294-1.09,1.646,1,.5Z",
    transform: "translate(-181.765 -34.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M265.589,50.8l-.644-.151-.678,1.85,1.092.256Z",
    transform: "translate(-184.067 -35.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M268.757,51.151H268.1l-.23,1.955h1.122Z",
    transform: "translate(-186.573 -35.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M271.447,50.654l-.644.151.23,1.955,1.092-.256Z",
    transform: "translate(-188.62 -35.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M273.517,49.686l-.591.294.679,1.85,1-.5Z",
    transform: "translate(-190.098 -34.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M275.381,48.3l-.507.421,1.09,1.646.86-.713Z",
    transform: "translate(-191.455 -33.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M276.939,46.57l-.4.525,1.443,1.353.67-.89Z",
    transform: "translate(-192.619 -32.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M278.108,44.59l-.262.6,1.718.988.444-1.019Z",
    transform: "translate(-193.525 -31.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M278.825,42.465l-.115.645,1.9.569.195-1.093Z",
    transform: "translate(-194.127 -29.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M278.962,39.546,279,40.2l1.98.121-.065-1.108Z",
    transform: "translate(-194.302 -27.312)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M.573,55.3,0,56.265v4.477H12.1V56.265l-.573-.963Z",
    transform: "translate(0 -38.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 3.39,
    height: 2.16,
    transform: "translate(0.144 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 3.39,
    height: 2.16,
    transform: "translate(4.403 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 3.39,
    height: 2.16,
    transform: "translate(8.62 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M.476,0V2.16h3.39Z",
    transform: "translate(-0.332 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M17.9,0l-3.39,2.16H17.9Z",
    transform: "translate(-10.106 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M31.795,0,28.4,2.16h3.39Z",
    transform: "translate(-19.784 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M14.509,0V2.16H17.9Z",
    transform: "translate(-10.106 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M14.156,7.117,3.08,11.994H13.365Z",
    transform: "translate(-2.145 -4.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M1.266,11.993l1.2,1.181h7.9l1.2-1.181L.476,7.117Z",
    transform: "translate(-0.331 -4.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M3.079,17.988l5.143-2.264,5.143,2.264-1.2,1.182h-7.9Z",
    transform: "translate(-2.145 -10.952)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2128",
    "data-name": "Group 2128",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2127",
    "data-name": "Group 2127",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2126",
    "data-name": "Group 2126",
    transform: "translate(0 17.746)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2125",
    "data-name": "Group 2125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2124",
    "data-name": "Group 2124",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M12.1,58.476,0,62.953H12.1Z",
    transform: "translate(0 -58.476)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M0,62.953H12.1L0,58.476Z",
    transform: "translate(0 -40.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M0,68.091H12.1L6.024,65.853Z",
    transform: "translate(0 -45.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M1.889,35.644l9.452-8.565,1.5,8.565Z",
    transform: "translate(-1.316 -18.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M1.888,35.644l1.557-8.565,9.4,8.565Z",
    transform: "translate(-1.315 -18.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M.476,7.117,6.409,9.729l5.933-2.612Z",
    transform: "translate(-0.332 -4.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M10.954,30.666l3.959-3.588h-7.9Z",
    transform: "translate(-4.888 -18.861)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhishfortLogo);
export default __webpack_public_path__ + "static/media/phishfortLogo.f3c2c19d4e71c7176c666821c008e20a.svg";
export { ForwardRef as ReactComponent };